<template>
    <div class="AddPageWarp">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" class="addnewseForm">
            <el-row :gutter="20">
                <el-col :span="24">
                    <el-form-item label="专家图片" prop="expertPicture">
                        <!--  :on-success="handleAvatarSuccess" -->
                        <!-- :show-file-list="false" -->
                        <el-upload id="imgupload" class="avatar-uploader" accept=".jpg,.png,.jpeg" list-type="picture-card" :on-remove="handleRemove"
                            :action="actionUrl" :headers="header" :limit="1" :file-list="imgfileList" :on-change="changePhotoFile"
                            :auto-upload="false" :show-file-list="showImg">
                            <i class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>

                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <div class="formtop">
                    <el-col :span="24">
                        <div>
                            <el-form-item label="专家姓名" prop="expertName">
                                <el-input v-model="ruleForm.expertName"></el-input>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item label="专家类别" prop="expertType">
                                <el-select v-model="ruleForm.expertType" placeholder="请选择" style="width:100%" @change="changeTypeFn">
                                    <el-option v-for="item in expertTypeArr" :key="item.dictionariesId" :label="item.dictMsg" :value="item.dictionariesId">
                                    </el-option>

                                </el-select>
                            </el-form-item>
                        </div>
                        <el-form-item label="其他专家类别" prop="otherInfo" v-if="changeType==358">
                            <el-input v-model="ruleForm.otherInfo"></el-input>
                        </el-form-item>
                    </el-col>
                </div>
            </el-row>

            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="所在单位" prop="unit">
                        <el-input v-model="ruleForm.unit"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="职务" prop="duty">
                        <el-input v-model="ruleForm.duty"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <!-- <el-row :gutter="20">
                <el-col :span="24">
                    <el-form-item label="证书编号" prop="certNumber">
                        <el-input v-model="ruleForm.certNumber"></el-input>
                    </el-form-item>
                </el-col>
            </el-row> -->
            <el-row :gutter="20">
                <el-col :span="24">
                    <el-form-item label="个人简介" prop="synopsis">
                        <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="ruleForm.synopsis">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <!-- <el-row :gutter="20">
                <el-col :span="24">
                    <el-form-item label="新闻内容" prop="content">
                        <div class="edithome">
                            <div id="edit"></div>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row> -->
             <div class="handleBox" v-if="tagName=='待审核'||tagName=='已发布'">
                <el-button @click="returnListFn">返回列表</el-button>
            </div>
            <div class="handleBox" v-else>
                <!-- <el-button @click="previewFn">预览</el-button> -->
                <el-button @click="draftForm('ruleForm')">暂存至草稿</el-button>
                <el-button @click="submitForm('ruleForm')">提交</el-button>
            </div>
        </el-form>
        <!-- vueCropper 剪裁图片实现-->
        <el-dialog title="图片剪裁" :visible.sync="dialogVisible" class="crop-dialog" append-to-body :close-on-click-modal="false" :close-on-press-escape='false'
            :show-close="false">
            <div class="cropper-content">
                <div class="cropper" style="text-align:center">
                    <vueCropper ref="cropper" :img="option.img" :outputSize="option.size" :outputType="option.outputType" :info="true" :full="option.full"
                        :canMove="option.canMove" :canMoveBox="option.canMoveBox" :original="option.original" :autoCrop="option.autoCrop"
                        :fixed="option.fixed" :fixedNumber="option.fixedNumber" :centerBox="option.centerBox" :infoTrue="option.infoTrue"
                        :fixedBox="option.fixedBox" :autoCropWidth="option.autoCropWidth" :autoCropHeight="option.autoCropHeight"
                        @cropMoving="cropMoving" @realTime="getCropImg" />
                </div>
            </div>
            <div class="action-box">
                <!-- <el-upload class="upload-demo"
                   action=""
                   :auto-upload="false"
                   :show-file-list="false"
                   :on-change='handleChangeUpload'>
            <el-button type="primary" plain>更换图片</el-button>
        </el-upload> -->
                <el-button type="primary" plain @click="clearImgHandle">清除图片</el-button>
                <el-button type="primary" plain @click="rotateLeftHandle">左旋转</el-button>
                <el-button type="primary" plain @click="rotateRightHandle">右旋转</el-button>
                <el-button type="primary" plain @click="changeScaleHandle(1)">放大</el-button>
                <el-button type="primary" plain @click="changeScaleHandle(-1)">缩小</el-button>
                <el-button type="primary" plain @click="downloadHandle('blob')">下载</el-button>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelImg">取 消</el-button>
                <el-button type="primary" @click="finish" :loading="loading">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { httpService, srcUrl, videoUrl } from "@/service/httpService";
import wangEditor from 'wangeditor'
import MyCropper from 'vue-cropper'
export default {
    components: { MyCropper },
    props: {
    // 接收父组件传递的 currentId
    currentId: {
      type: String,
      default: null
    },
    // 接收父组件传递的 tagName
    tagName: {
      type: String,
      default: ''
    }
  },
    data() {
        return {
            srcUrl: srcUrl,
            videoUrl: videoUrl,
            actionUrl: process.env.VUE_APP_GATEWAY + '/upload/addfile',
            ruleForm: {
                expertPicture: '',
                expertName: '',
                expertType: '',
                otherInfo: '',//其他专家类型描述
                unit: '',
                duty: '',
                // certNumber: '',
                synopsis: '',
            },
            rules: {
                expertPicture: [
                    { required: true, message: '请上传图片', trigger: 'change' }
                ],
                duty: [
                    { required: true, message: '请输入标题', trigger: 'blur' },
                ],
                expertName: [
                    { required: true, message: '请输入', trigger: 'blur' }
                ],
                expertType: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                otherInfo: [
                    { required: true, message: '请输入', trigger: 'blur' },
                ],
                unit: [
                    { required: true, message: '请输入', trigger: 'blur' },
                ],

                // certNumber: [
                //     { required: true, message: '请输入', trigger: 'blur' }
                // ],
                synopsis: [
                    { required: true, message: '请填写简介', trigger: 'blur' }
                ],

            },
            changeType: '',
            editor: null,
            editorData: '',
            header: null,
            expertPictureList: [],
            imgfileList: [],
            fileList: [],
            pickerOptions: {
                disabledDate: this.disabledDate
            },
            expertTypeArr: [],
            id: '',
            isPreview: false,
            dialogVisible: false,
            previewImg: '', // 预览图片地址
            // 裁剪组件的基础配置option
            option: {
                img: 'https://pic1.zhimg.com/80/v2-366c0aeae2b4050fa2fcbfc09c74aad4_720w.jpg', // 裁剪图片的地址
                info: true, // 裁剪框的大小信息
                outputSize: 1, // 裁剪生成图片的质量
                outputType: 'png', // 裁剪生成图片的格式
                canScale: true, // 图片是否允许滚轮缩放
                autoCrop: true, // 是否默认生成截图框
                canMoveBox: true, // 截图框能否拖动
                // autoCropWidth:202, // 默认生成截图框宽度
                autoCropHeight: 280, // 默认生成截图框高度
                fixedBox: false, // 固定截图框大小 不允许改变
                fixed: true, // 是否开启截图框宽高固定比例
                fixedNumber: [3, 4], // 截图框的宽高比例
                full: false, // 是否输出原图比例的截图
                original: false, // 上传图片按照原始比例渲染
                centerBox: false, // 截图框是否被限制在图片里面
                infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
            },
            // 防止重复提交
            loading: false,
            imgFile: '',
            showImg: false,//显示图片
            showBtn: '',
            tagTab:'',
        }
    },
    created() {
        // 修改新闻
        // this.id = this.$route.query.id || this.$route.params.id;
        // this.showBtn = this.$route.query.showBtn
        // this.tagTab=this.$route.query.tag
        if (this.currentId) {
            this.getNews(this.currentId)
        }
        this.getexpertType()

    },

    mounted() {

    },

    methods: {
        // 获取编辑的新闻
        async getNews(id) {
            let data = await httpService.getSingleBusexpertById(id);
            if (data.code == 200) {
                this.ruleForm = data.result
                this.imgfileList = [
                    { url: srcUrl + this.ruleForm.expertPicture, name: this.ruleForm.expertPicture }
                ]
                if (this.imgfileList.length > 0) {
                    document.querySelector('.el-upload--picture-card').style.display = 'none'
                    this.showImg = true
                }

                this.changeType = this.ruleForm.expertType
                console.log(this.imgfileList, 'this.imgfileList');
            }
            console.log(this.ruleForm, 'this.ruleForm');
        },
        // 重置
        resetForm() {
            this.$refs['ruleForm'].resetFields();
            this.fileList = []
            this.imgfileList = []
            if (this.imgfileList.length == 0) {
                document.querySelector('#imgupload').firstChild.nextSibling.style.display = 'inline-block'
            }
            // this.editor.txt.html('')
        },
        //获取发布栏目
        getexpertType() {
            httpService.dataDictionary({ params: { fieldName: 'expertType' } }).then(res => {
                if (res.code == 200) {
                    console.log(res);
                    this.expertTypeArr = res.result
                }
            })
        },
        changeTypeFn(e) {
            this.changeType = e
        },
        submitForm(formName) {
            // this.ruleForm.content = this.editor.txt.html()
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.ruleForm.audit = 1;//1保存0草稿
                    // this.ruleForm.content = this.editor.txt.html()
                    if (this.fileList.length != 0) {
                        let filearr = []
                        this.fileList.map(ele => {
                            if (ele.response) {
                                filearr.push(ele.response.result)

                            } else {
                                filearr.push(ele.name)
                            }
                        })
                        this.ruleForm.downloadAttachment = filearr.join(',')
                    }
                    if (this.currentId) {
                        // 修改新闻
                        httpService.updateExpert(this.ruleForm).then(res => {
                            if (res.code == 200) {
                                this.$message({
                                    message: '修改成功',
                                    type: 'success'
                                });
                                this.resetForm()
                               this.$emit('modifySuccess', '待审核');
                            } else {
                                this.$message.error(res.message);
                            }
                        })
                    } else {
                        httpService.insertExpert(this.ruleForm).then(res => {
                            if (res.code == 200) {
                                this.$message({
                                    message: '提交成功',
                                    type: 'success'
                                });
                                this.resetForm()
                                sessionStorage.removeItem('formdata')
                                this.$emit('modifySuccess', '待审核');
                            } else {
                                this.$message.error(res.message);
                            }
                        })
                    }

                } else {
                    return false;
                }
            });
        },
        draftForm() {
            // this.ruleForm.content = this.editor.txt.html()
            if (this.fileList.length != 0) {
                let filearr = []
                this.fileList.map(ele => {
                    if (ele.response) {
                        filearr.push(ele.response.result)

                    } else {
                        filearr.push(ele.name)
                    }
                })
                this.ruleForm.downloadAttachment = filearr.join(',')
            }
            if (!this.ruleForm.expertPicture || !this.ruleForm.expertType || !this.ruleForm.unit || !this.ruleForm.duty) {
                this.$message({
                    message: '专家图片、专家类别、单位、职务四项为保存草稿必填项,请检查是否填写完整',
                    type: 'warning'
                });
                return
            }
            else {
                this.ruleForm.audit = 0
                if (this.currentId) {
                    // 修改新闻
                    httpService.updateExpert(this.ruleForm).then(res => {
                        if (res.code == 200) {
                            this.$message({
                                message: '草稿编辑保存成功',
                                type: 'success'
                            });
                            // this.resetForm()
                            // let arr=[]
                            // let obj
                            // arr.forEach(ele=>{

                            // })
                            sessionStorage.removeItem('formdata')
                          this.$emit('modifySuccess', '草稿');
                        } else {
                            this.$message.error(res.message);
                        }

                    })
                } else {
                    httpService.insertExpert(this.ruleForm).then(res => {
                        if (res.code == 200) {
                            this.$message({
                                message: '草稿保存成功',
                                type: 'success'
                            });
                            // this.resetForm()
                            sessionStorage.removeItem('formdata')
                            this.$emit('modifySuccess', '草稿');
                        } else {
                            this.$message.error(res.message);
                        }
                    })
                }

            }
        },
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        // // 获取富文本内容
        // getEditorData() {
        //     // 通过代码获取编辑器内容
        //     let data = this.editor.txt.html()
        //     alert(data)
        // }
        // 返回列表
        returnListFn() {
            console.log('清空');
            this.$emit('modifySuccess', this.tagName); 
           
        },
        previewFn(file, fileList) {
            // this.ruleForm.content = this.editor.txt.html()
            sessionStorage.setItem("formdata", JSON.stringify(this.ruleForm));
            //   sessionStorage.removeItem("site");
            this.$router.push('/account-center/perview-news');
        },
        // 图片上传
        // handleAvatarSuccess(res, file, fileList) {
        //     //  const isLt2M = file.size / 1024 / 1024 < 2;
        //     // if (!isLt2M) {
        //     //     this.$message.error('上传图片大小不能超过 2MB!');
        //     //     return false
        //     // }
        //     if (res.code == 200) {
        //         this.imgfileList = fileList
        //         this.ruleForm.expertPicture = res.result
        //         if (this.imgfileList.length > 0) {
        //             document.querySelector('#imgupload').firstChild.nextSibling.style.display = 'none'
        //         }
        //         this.$nextTick(async () => {
        //             // base64方式
        //             // this.option.img = await fileByBase64(file.raw)
        //             this.option.img = URL.createObjectURL(file.raw)
        //             this.loading = false
        //             this.dialogVisible = true
        //         })
        //     }

        // },
        //上传图片时会被调用
        changePhotoFile(file, fileList) {
            this.$nextTick(async () => {
                // base64方式
                // this.option.img = await fileByBase64(file.raw)
                this.option.img = URL.createObjectURL(file.raw)
                this.loading = false
                this.dialogVisible = true;
            })
        },
        // 放大/缩小
        changeScaleHandle(num) {
            num = num || 1;
            this.$refs.cropper.changeScale(num);
        },
        // 左旋转
        rotateLeftHandle() {
            this.$refs.cropper.rotateLeft();
        },
        // 右旋转
        rotateRightHandle() {
            this.$refs.cropper.rotateRight();
        },
        // 下载
        downloadHandle(type) {
            let aLink = document.createElement('a')
            aLink.download = 'author-img'
            if (type === 'blob') {
                this.$refs.cropper.getCropBlob((data) => {
                    let downImg = window.URL.createObjectURL(data)
                    aLink.href = window.URL.createObjectURL(data)
                    aLink.click()
                })
            } else {
                this.$refs.cropper.getCropData((data) => {
                    let downImg = data;
                    aLink.href = data;
                    aLink.click()
                })
            }
        },
        // 清理图片
        clearImgHandle() {
            this.option.img = ''
        },
        // 截图框移动回调函数
        cropMoving(data) {
            // 截图框的左上角 x，y和右下角坐标x，y
            // let cropAxis = [data.axis.x1, data.axis.y1, data.axis.x2, data.axis.y2]
            // console.log(cropAxis)
        },
        getCropImg() {
            if (this.option.outputType === "blob") {
                this.$refs.cropper.getCropBlob(data => {
                    // var img = window.URL.createObjectURL(data);
                    var img = data;
                    this.imgFile = img;
                });
            } else {
                this.$refs.cropper.getCropData(data => {
                    this.imgFile = data;
                    this.imgFile = this.base64ToFile(data, 'docpic.jpg')
                });
            }
        },
        base64ToFile(urlData, fileName) {
            let arr = urlData.split(',');
            let mime = arr[0].match(/:(.*?);/)[1];
            let bytes = atob(arr[1]); // 解码base64
            let n = bytes.length
            let ia = new Uint8Array(n);
            while (n--) {
                ia[n] = bytes.charCodeAt(n);
            }
            return new File([ia], fileName, { type: mime });
        },
        finish() {
            // 获取截图的 blob 数据
            this.$refs.cropper.getCropBlob((blob) => {
                this.loading = true
                this.dialogVisible = false
                this.previewImg = URL.createObjectURL(blob)
                this.isPreview = true
                this.$refs.cropper.getCropBlob((blob) => {
                    const formData = new FormData();
                    formData.append("file", this.imgFile)
                    httpService.addfile(formData).then(res => {
                        if (res.code == 200) {
                            this.imgfileList = [
                                { url: srcUrl + res.result, name: res.result }
                            ]
                            this.showImg = true
                            this.ruleForm.expertPicture = res.result
                            if (this.imgfileList.length > 0) {
                                document.querySelector('.el-upload--picture-card').style.display = 'none'
                            }
                        }
                    })
                });
            })
            // 获取截图的 base64 数据
            // this.$refs.cropper.getCropData(data => {
            //     console.log(data)
            // })
        },
        cancelImg() {
            //  this.showImg=false
            //  document.querySelector('#imgupload').firstChild.firstChild.style.display = 'none'
            this.dialogVisible = false
            //  let remomvList= document.querySelector('#imgupload').firstChild
            //  remomvList.removeChild(remomvList.childNodes[0])
            //   document.querySelector('#imgupload').firstChild.removeChild(remomv)
            // document.querySelector('#imgupload').firstChild.firstChild.style.display = 'inline-block'
            //  document.querySelector('.el-upload--picture-card').style.display = 'inline-block'
            const formData = new FormData();
            formData.append("file", this.imgFile)
            httpService.addfile(formData).then(res => {
                if (res.code == 200) {
                    this.imgfileList = [
                        { url: srcUrl + res.result, name: res.result }
                    ]
                    this.showImg = true
                    this.ruleForm.expertPicture = res.result
                    if (this.imgfileList.length > 0) {
                        document.querySelector('.el-upload--picture-card').style.display = 'none'
                    }
                }
            })
        },
        // 删除
        handleRemove(file, fileList) {
            this.imgfileList = []
            if (this.imgfileList.length == 0) {
                document.querySelector('#imgupload').firstChild.nextSibling.style.display = 'inline-block'
            }
        },
        // 文件
        handlefileSuccess(res, file, fileList) {
            if (res.code == 200) {
                this.fileList = fileList
            }
        },
        handlefileRemove(file, fileList) {
            this.fileList = fileList
        },

        disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7
        },

    },
    beforeDestroy() {
        // // 调用销毁 API 对当前编辑器实例进行销毁
        // this.editor.destroy()
        // this.editor = null
        this.showBtn=''
    }
}
</script>
<style lang="less" scoped>
.AddPageWarp {
  padding: 30px 400px 20px 80px;
  .addnewseForm {
    .formtop {
      display: flex;
      flex-direction: row;
    }
    .edithome {
      width: 100%;
      margin: auto;
      position: relative;
      z-index: 0;
      .btn {
        position: absolute;
        right: 0;
        top: 0;
        padding: 5px 10px;
        cursor: pointer;
      }
      h3 {
        margin: 30px 0 15px;
      }
    }
    .handleBox {
      // width: 676px;
      margin: 10px auto 0 130px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      .el-button {
        width: 152px;
        height: 40px;
        border-radius: 5px;
        border: none;
        color: #fff;
        margin: 0 15px;
        &:nth-child(1) {
          background: #5cdf7a;

          box-shadow: 0px 2px 10px #5cdf7a;
        }
        &:nth-child(2) {
          background: #0083ff;
          box-shadow: 0px 2px 10px #0083ff;
        }
        &:nth-child(3) {
          background: #ffc56d;
          box-shadow: 0px 2px 10px #ffc56d;
        }
        &:nth-child(4) {
          border: 1px solid #e8e8e8;
          box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.03);
          color: #a6a9b7;
        }
      }
    }
  }
}
.cropper-content {
  .cropper {
    width: auto;
    height: 350px;
  }
}
</style>